import { motion } from "framer-motion";
import styled from "styled-components";
export const CodeButton = styled(motion.div)`
  position: fixed;
  width: 40rem;
  height: 4rem;
  background-color: white;
  border-radius: 20px;
  bottom: 0;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
